import Dashboard from './pages/Dashboard';
import Suppliers from './pages/procurement/Suppliers';
import Materials from './pages/procurement/Materials';
import Categories from './pages/procurement/Categories';
import PurchaseOrders from './pages/procurement/PurchaseOrders';
import PurchaseOrderForm from './pages/procurement/PurchaseOrderForm';
import Customers from './pages/sales/Customers';
import Products from './pages/sales/Products';
import SalesOrders from './pages/sales/SalesOrders';
import SalesOrderForm from './pages/sales/SalesOrderForm';
import FinancialRecords from './pages/FinancialRecords';
import ProductionPlans from './pages/production/ProductionPlans'; // Import new component
import {
    PieChartOutlined,
    ShoppingOutlined,
    AuditOutlined,
    ContainerOutlined,
    TeamOutlined,
    TagsOutlined,
    UsergroupAddOutlined,
    DollarCircleOutlined,
    FileTextOutlined,
    ToolOutlined, // Import new icon
    AppstoreOutlined,
} from '@ant-design/icons';
import React from 'react';
import { Link } from 'react-router-dom';

// 1. Route Component Mapping
export const routeConfig = {
    '/dashboard': { component: <Dashboard />, title: '首页' },
    '/procurement/suppliers': { component: <Suppliers />, title: '供应商管理' },
    '/procurement/materials': { component: <Materials />, title: '物料管理' },
    '/procurement/categories': { component: <Categories />, title: '分类管理' },
    '/procurement/purchase-orders': { component: <PurchaseOrders />, title: '采购订单' },
    '/procurement/purchase-orders/new': { component: <PurchaseOrderForm />, title: '新建采购订单' },
    '/procurement/purchase-orders/:id': { component: <PurchaseOrderForm />, title: '编辑采购订单' },
    '/production/plans': { component: <ProductionPlans />, title: '生产计划' }, // Add route for plans
    '/production/products': { component: <Products />, title: '产品管理' }, 
    '/sales/customers': { component: <Customers />, title: '客户管理' },
    '/sales/sales-orders': { component: <SalesOrders />, title: '销售订单' },
    '/sales/sales-orders/new': { component: <SalesOrderForm />, title: '新建销售订单' },
    '/sales/sales-orders/:id': { component: <SalesOrderForm />, title: '编辑销售订单' },
    '/financial-records': { component: <FinancialRecords />, title: '收支记录' },
};


// 2. Menu Structure Definition
const getItem = (label, key, icon, children, type) => {
  return {
    key,
    icon,
    children,
    label: children ? label : <Link to={key}>{label}</Link>,
    type,
  };
};

export const menuItems = [
  getItem('仪表盘', '/dashboard', <PieChartOutlined />),
  getItem('采购管理', 'procurement', <ShoppingOutlined />, [
    getItem('物料管理', '/procurement/materials', <ContainerOutlined />),
    getItem('分类管理', '/procurement/categories', <AppstoreOutlined />),
    getItem('供应商管理', '/procurement/suppliers', <TeamOutlined />),
    getItem('采购订单', '/procurement/purchase-orders', <AuditOutlined />),
  ]),
  getItem('生产管理', 'production', <ToolOutlined />, [
    getItem('生产计划', '/production/plans', <FileTextOutlined />),
    getItem('产品管理', '/production/products', <ContainerOutlined />),
  ]),
  getItem('销售管理', 'sales', <TagsOutlined />, [
    getItem('客户管理', '/sales/customers', <UsergroupAddOutlined />),
    getItem('销售订单', '/sales/sales-orders', <AuditOutlined />),
  ]),
  getItem('财务管理', 'financial-records', <DollarCircleOutlined />, [
    getItem('收支记录', '/financial-records', <FileTextOutlined />),
  ]),
];